/* PERROWALL — barre livraison offerte : secours JS.
 * La barre (snippet pw-shipping-bar) est rendue en pur Liquid et se met à jour
 * au re-render serveur du panier (morph). Ce script recalcule en plus sur
 * l'event cart:update au cas où la zone ne serait pas morphée (ex. page panier).
 */
(function () {
  'use strict';

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  var DONE = '<svg class="pw-shipbar__ico" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg> Livraison offerte débloquée';

  function render(bar, total) {
    var th = parseInt(bar.getAttribute('data-threshold') || '0', 10);
    if (!th) { return; }
    var remaining = th - total;
    var pct = Math.min(100, Math.round((total * 100) / th));
    var fill = bar.querySelector('.pw-shipbar__fill');
    var msg = bar.querySelector('.pw-shipbar__msg');
    var track = bar.querySelector('.pw-shipbar__track');
    if (fill) { fill.style.width = pct + '%'; }
    if (track) { track.setAttribute('aria-valuenow', String(total)); }
    var was = bar.classList.contains('pw-shipbar--done');
    if (remaining > 0) {
      bar.classList.remove('pw-shipbar--done');
      if (msg) { msg.innerHTML = 'Plus que <strong>' + fmt(remaining) + '</strong> pour la <strong>livraison offerte</strong>'; }
    } else {
      bar.classList.add('pw-shipbar--done');
      if (msg) { msg.innerHTML = DONE; }
      if (!was) {
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'pw_freeship_unlocked' }); } catch (e) {}
      }
    }
  }

  document.addEventListener('cart:update', function (e) {
    var total = e && e.detail && e.detail.resource && e.detail.resource.total_price;
    if (typeof total !== 'number') { return; }
    var bars = document.querySelectorAll('[data-pw-shipbar]');
    for (var i = 0; i < bars.length; i++) { render(bars[i], total); }
  });
})();
